import { FC } from 'react';
import { ILayoutBase } from '../../types';
import Navbar from './navbar';
import Sidebar from './sidebar';
import styles from './styles.module.css';

const LayoutDefault: FC<ILayoutBase> = (props) => {

  const {
    title,
    children,
  } = props;

  return (
    <div style={{ minHeight: '100vh' }}>

      <Navbar />

      <div className={styles.container}>

        <Sidebar />

        <section className="section" style={{ width: '100%' }}>
          <div className="container">

            {Boolean(title) && (
              <h1 className="title">
                {title}
              </h1>
            )}

            {children}

          </div>
        </section>
      </div>
    </div>
  );

};

export default LayoutDefault;
